import React, { useState, useRef, useEffect } from 'react';
import { ReactComponent as SearchIcon } from "../../../../../myfin_v2/assets/icons/search.svg";

const AccordionHeaderActions = ({
    searchValue = "",
    onSearchChange,
    searchPlaceholder = "Search...",
}) => {
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const searchInputRef = useRef(null);

    useEffect(() => {
        if (isSearchOpen && searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [isSearchOpen]);

    const handleClearOrCloseSearch = (e) => {
        e.stopPropagation();
        if (searchValue) {
            onSearchChange("");
        } else {
            setIsSearchOpen(false);
        }
    };

    return (
        <div
            className="d-flex align-items-center"
            style={{ gap: "8px", background: "transparent" }}
            onClick={(e) => e.stopPropagation()}
        >
            <div className="d-flex align-items-center position-relative" style={{ background: "transparent" }}>
                {!isSearchOpen ? (
                    <div
                        role="button"
                        tabIndex={-1}
                        onClick={(e) => {
                            e.stopPropagation();
                            setIsSearchOpen(true);
                        }}
                        style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "28px",
                            height: "28px",
                            backgroundColor: "transparent",
                            border: "none",
                            boxShadow: "none",
                            outline: "none",
                        }}
                        title="Search"
                    >
                        <SearchIcon style={{ width: "17px", height: "17px" }} />
                    </div>
                ) : (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            background: "transparent",
                            backgroundColor: "transparent",
                            borderTop: "none",
                            borderLeft: "none",
                            borderRight: "none",
                            border: "1.5px solid #c2e6d1",
                            borderRadius: "6px",
                            boxShadow: "none",
                            outline: "none",
                            padding: "2px 4px",
                            height: "34px",
                            width: "400px",
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <SearchIcon style={{ width: "16px", height: "16px", marginRight: "6px", flexShrink: 0 }} />
                        <input
                            ref={searchInputRef}
                            type="text"
                            autoComplete="off"
                            value={searchValue}
                            placeholder={searchPlaceholder}
                            onChange={(e) => onSearchChange(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Escape") {
                                    onSearchChange("");
                                    setIsSearchOpen(false);
                                }
                            }}
                            style={{
                                border: "none",
                                outline: "none",
                                background: "transparent",
                                backgroundColor: "transparent",
                                boxShadow: "none",
                                width: "100%",
                                fontSize: "13px",
                                color: "#183930",
                            }}
                        />
                        <button
                            type="button"
                            onClick={handleClearOrCloseSearch}
                            style={{
                                border: "none",
                                background: "transparent",
                                backgroundColor: "transparent",
                                boxShadow: "none",
                                outline: "none",
                                cursor: "pointer",
                                padding: "0 2px",
                                display: "flex",
                                alignItems: "center",
                                color: "#809790",
                                fontSize: "18px",
                                lineHeight: 1,
                            }}
                            title={searchValue ? "Clear search" : "Close search"}
                        >
                            &times;
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AccordionHeaderActions;
